"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = require("react");

var forEachClassName = function forEachClassName(classNames, cb) {
  classNames.trim().split(/\s+/).forEach(function (className) {
    cb(className);
  });
};
/**
 * Passes the child component through directly, while toggling
 * the body class according to the bodyClassName prop
 */


var ComponentWithBodyClass =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(ComponentWithBodyClass, _Component);

  function ComponentWithBodyClass() {
    (0, _classCallCheck2.default)(this, ComponentWithBodyClass);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ComponentWithBodyClass).apply(this, arguments));
  }

  (0, _createClass2.default)(ComponentWithBodyClass, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.toggleBodyClass(true, this.props.bodyClassName);
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(_ref) {
      var bodyClassName = _ref.bodyClassName;

      if (bodyClassName !== this.props.bodyClassName) {
        this.toggleBodyClass(false, this.props.bodyClassName);
        this.toggleBodyClass(true, bodyClassName);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.toggleBodyClass(false, this.props.bodyClassName);
    }
  }, {
    key: "toggleBodyClass",
    value: function toggleBodyClass(isMounting, bodyClassName) {
      var bodyElement = this.props.bodyElement;

      if (bodyClassName && bodyElement) {
        var func = isMounting ? 'add' : 'remove';
        forEachClassName(bodyClassName, function (className) {
          bodyElement.classList[func](className);
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);
  return ComponentWithBodyClass;
}(_react.Component);

exports.default = ComponentWithBodyClass;
ComponentWithBodyClass.propTypes = {
  bodyClassName: _propTypes.default.string.isRequired,
  bodyElement: _propTypes.default.object.isRequired,
  children: _propTypes.default.node
};
ComponentWithBodyClass.defaultProps = {
  bodyElement: document.body
};
ComponentWithBodyClass.displayName = 'ComponentWithBodyClass';
module.exports = exports.default;